export function formatUnixTimestamp(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000) // Convert seconds to milliseconds

  // Format options for US users
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }

  return new Intl.DateTimeFormat("en-US", options).format(date)
}

// Sort Utility
export const sortData = (data, sortConfig) => {
  if (sortConfig?.key) {
    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key]?.toString().toLowerCase() || ""
      const bValue = b[sortConfig.key]?.toString().toLowerCase() || ""
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1
      return 0
    })
  }
  return data
}

// Pagination Utility
export const paginateData = (data, currentPage, itemsPerPage) => {
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = currentPage * itemsPerPage
  return data.slice(startIndex, endIndex)
}
